/** @jsx jsx */

import { SkeletonLoader, SkeletonText, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const getRootCss = padding =>
  css({
    padding,
  });

type Props = {
  padding: number | string;
  label?: string;
  ariaLabel?: string;
};

const defaultProps = {
  padding: '15px',
  ariaLabel: 'Loading results',
};

function ValidatingLoader({ ariaLabel, padding, label }: Props) {
  return (
    <aside aria-label={ariaLabel} css={getRootCss(padding)}>
      {label && <Text tag="p">{label}</Text>}
      <SkeletonLoader>
        <SkeletonText lines={3} size="heading" width="80%" />
      </SkeletonLoader>
    </aside>
  );
}

ValidatingLoader.defaultProps = defaultProps;

export default ValidatingLoader;
